export default "__VITE_ASSET__DY6A905e__"